import {action, computed, makeAutoObservable, observable} from 'mobx'

export class BusinessStore {
  showFeedback: boolean = false

  constructor() {
    makeAutoObservable(this, {
      showFeedback: observable,
      toggleFeedback: action,
      getShowFeedback: computed,
    });
  }

  toggleFeedback = () => {
    this.showFeedback = !this.showFeedback
  }

  get getShowFeedback() {
    return this.showFeedback;
  }
}